import Vue from 'vue';
import SimpleVueValidation from 'simple-vue-validator';
import util from "@/mixins/util";

const Validator = SimpleVueValidation.Validator;

Vue.use(SimpleVueValidation);

export default {
    data() {
        return {
            category: '',
            selectMember: {},
            files: [],
            collection: '',
            thumbnailFile: [],
            originalFile: [],
            collectionList: [],
            title: '',
            intro: '',
            owner: '',
            backImg: [],
            mainImg: [],
            zipFiles:[],
        }
    },
    validators: {
        category: function (value) {
            return Validator.value(value)
                    .required('카테고리를 선택해주세요.')
        },
        selectMember: function (value) {
            return Validator.value(value)
                    .custom(() => {
                                if (util.isEmpty(value)) {
                                    return '회원을 선택해주세요.'
                                }
                            }
                    )
        },
        collection: function (value) {
            return Validator.value(value)
                    .required('컬렉션을 선택해주세요.')
        },
        files: function (value) {
            return Validator.value(value)
                    .custom(() => {
                                if (value.length === 0) {
                                    return '파일을 등록해주세요.'
                                }
                            }
                    )
        },
        title: function (value) {
            return Validator.value(value)
                    .required('컬렉션명을 입력해주세요.')
                    .custom(() => {
                                if (util.isEmpty(value)) {
                                    return '컬렉션명을 입력해주세요.'
                                }
                            }
                    )

        },
        intro: function (value) {
            return Validator.value(value)
        },
        owner: function (value) {
            return Validator.value(value)
        },
        backImg: function (value) {
            return Validator.value(value)

        },
        mainImg: function (value) {
            return Validator.value(value)

        },
        zipFiles: function (value) {
            return Validator.value(value)
                    .custom(() => {
                                if (value.length === 0) {
                                    return '파일을 등록해주세요.'
                                }
                            }
                    )
        },

    }
}
